import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import CarouselWrapper from '../shared/Carousel/CarouselWrapper/CarouselWrapper';
import TrialCardItem from '../CR/TrialCardItem';
import {
  STCRWrapper,
  StCRGridContainer,
  StCommonTypography,
} from '../shared/Container/Container.styles';
import { JSSLink } from '../shared/Links/JSSLink.styles';
import useSavedTrialsResultList from '../../lib/hooks/coveo/useSavedTrialsResultList';
import { useEffect, useState } from 'react';
import savedTrialHeadlessEnginee from 'lib/utils/coveo/savedTrialHeadlessEngine';

const fallbackField = {
  value: 'fallbackValue',
};

const fallbackViewAllField = {
  href: '/manage-my-profile/Saved-Trials',
  text: 'View all saved trials',
};

const TrialItemsManageProfile = (props: any) => {
  const theme = useTheme();
  const { sitecoreContext } = useSitecoreContext();
  const isMyProfilePage = sitecoreContext?.route?.fields?.isMyProfilePage;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [trialsList, setTrialsList] = useState<any>([]);
  const title = props?.fields?.title || fallbackField;
  const viewAllButton = props?.fields?.viewAllButton || fallbackViewAllField;

  const { state } = useSavedTrialsResultList(
    savedTrialHeadlessEnginee,
    props?.fields?.noOfRecordsPerPage?.value || 12
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setTrialsList(state?.results);
    }
  }, [state]);

  const [fieldsData] = useState(() => {
    const fieldsData: any = [];
    props?.fields?.searchTrialFields?.forEach((item: any) => {
      if (item?.fields?.key?.value && item?.fields?.icon?.value && item?.fields?.label?.value) {
        fieldsData.push({
          label: item?.fields?.label,
          icon: item?.fields?.icon,
          key: item?.fields?.key,
        });
      }
    });
    return fieldsData;
  });

  const trialCardItemDataArr: any = [];

  if (Array.isArray(trialsList)) {
    trialsList?.forEach((trial: any) => {
      trialCardItemDataArr.push({
        fieldsData,
        coveoTrialObj: trial,
      });
    });
  }

  const SimpleTrialView = (modalProps: any) => {
    return (
      <STCRWrapper>
        <StCRGridContainer
          sx={{
            ...(isMobile && {
              marginInline: (theme) => `${theme.spacing(0)}!important`,
              padding: '0px',
            }),
          }}
        >
          <Box
            display={'flex'}
            sx={{
              overflowX: 'auto',
              gap: theme.spacing(2),
              ...((trialCardItemDataArr?.length === 1 ||
                (!isMobile && trialCardItemDataArr?.length < 3)) && {
                justifyContent: { lg: 'center' },
              }),
            }}
          >
            {trialCardItemDataArr.map((item: any, index: number) => {
              return (
                <TrialCardItem
                  data={item}
                  style={{ maxWidth: '393px', minWidth: '330px' }}
                  key={index}
                  modalProps={modalProps}
                  state={state}
                />
              );
            })}
          </Box>
        </StCRGridContainer>
      </STCRWrapper>
    );
  };

  const modalProps = {
    title: props?.fields?.modalTitle,
    description: props?.fields?.modalDescription,
    customButtons: props?.fields?.modalCTAButtons,
  };

  return (
    <>
      {Array.isArray(trialCardItemDataArr) && trialCardItemDataArr.length > 0 ? (
        <Box
          sx={{
            backgroundColor: theme.palette.white.main,
            ...(isMyProfilePage && { backgroundColor: theme.palette.backgroundColorType3.main }),
          }}
          id="article-carousel"
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: '48px 41px',
              maxWidth: '1400px',
              marginInline: 'auto',
            }}
          >
            <StCommonTypography
              sx={{
                textAlign: 'center',
                fontWeight: 600,
                fontSize: '32px',
                lineHeight: '24px',
                marginBottom: '1rem',
                color: theme.palette.neutral8.main,
                [theme.breakpoints.down('sm')]: {
                  fontSize: '24px',
                  ...(isMyProfilePage && { textAlign: 'start' }),
                },
              }}
            >
              <Text field={title} />
            </StCommonTypography>

            {Array.isArray(trialCardItemDataArr) && trialCardItemDataArr.length > 3 ? (
              <CarouselWrapper
                {...props}
                callerComponent="saved-trials"
                data={trialCardItemDataArr}
                modalProps={modalProps}
                state={state}
              />
            ) : (
              <SimpleTrialView modalProps={modalProps} />
            )}
            <>
              {Array.isArray(trialCardItemDataArr) && trialCardItemDataArr.length > 0 && (
                <Box display={'flex'} justifyContent={'center'} marginTop={'1rem'}>
                  <JSSLink field={viewAllButton}></JSSLink>
                </Box>
              )}
            </>
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};
export default TrialItemsManageProfile;
